import axios from 'axios';
import Release from '../entity/release.entity';

export default class ReleaseService {
  public static getRelease(): Promise<Release> {
    return axios.get('/release-api/release/last?productName=people-management')
      .then(({ data }) => new Release(data));
  }
}
